import React from "react";

const content = `<svg xmlns="http://www.w3.org/2000/svg"><style>.spinner_Pcrv{transform-origin:center;animation:spinner_xeMo .6s linear infinite}@keyframes spinner_xeMo{100%{transform:rotate(360deg)}}</style><path class="spinner_Pcrv" d="M2,12A10.94,10.94,0,0,1,5,4.65c-.21-.19-.42-.36-.62-.55h0A11,11,0,0,0,12,23c.34,0,.67,0,1-.05C6,23,2,17.74,2,12Z"/></svg>`

interface SpinnerProps extends React.SVGProps<SVGSVGElement> { }

export function Spinner({ ...props }: SpinnerProps) {
    const { className } = props;
    return <svg
        {...props}
        stroke="currentcolor"
        className={(className || "") + ' w-10 h-10 text-[#F4E3F7]'}
        dangerouslySetInnerHTML={{ __html: content }}
        width="24" height="24" viewBox="0 0 24 24"
    >

    </svg>
}